query StreamEntrypointsListQuery(
  $page: Int
  $rowsPerPage: Int
  $filter: StreamEntrypointsFilterInput
) {
  streamEntrypoints(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      liveConnected
      createdAt
      platform {
        id
        title
      }
      stream {
        id
        title
      }
      pull {
        status
      }
    }
  }
}
